import { ErrorView } from '@atlassian/mpac-ui';
import React from 'react';
import { isEmceeConnect } from '../../utils/package-connect-utils';
import useEmceeLinks from '../hooks/useEmceeLinks';
import ErrorWindow from './ErrorWindow.svg';
const NotFound = props => {
  const {
    discoverHome
  } = useEmceeLinks();
  const homeLink = discoverHome.getRelative();
  const hideGoBackLink = !!isEmceeConnect();
  return /*#__PURE__*/React.createElement(ErrorView, {
    homeLink: homeLink,
    heading: "Looks like you took a wrong turn",
    image: ErrorWindow,
    primaryMessage: "This page does not exist",
    statusCode: 404,
    history: props.history,
    hideGoBackLink: hideGoBackLink
  });
};
export default NotFound;